<template>
  <section class="pb-8" id="contact">
    <!-- <v-container fluid>
      <v-row align="center" justify="center">
        <v-col cols="10">
          <v-row justify="center">
            <v-col cols="12" sm="5">
              <h1 class="font-weight-light display-1">Contate-nos</h1>
              <h3 class="font-weight-light mt-3">
                Tire suas dúvidas no formulário ao lado.
              </h3>
              <h3 class="font-weight-light mt-3">Respondemos em até 2 dias.</h3>
            </v-col>
            <v-col cols="12" sm="7">
              <v-form
                ref="form"
                id="form"
                v-model="valid"
                :lazy-validation="lazy"
              >
                <v-text-field
                  v-model="name"
                  :rules="nameRules"
                  label="Nome"
                  required
                  @input="checkSubmit"
                ></v-text-field>

                <v-text-field
                  v-model="email"
                  :rules="emailRules"
                  label="E-mail"
                  required
                  @input="checkSubmit"
                ></v-text-field>

                <v-textarea
                  v-model="textArea"
                  :rules="textAreaRules"
                  label="Mensagem"
                  required
                  @input="checkSubmit"
                />
                <vue-recaptcha
                  ref="invisibleRecaptcha"
                  badge="bottomleft"
                  @verify="onVerify"
                  @expired="onExpired"
                  @error="errorMethod"
                  size="invisible"
                  :sitekey="siteKey"
                >
                </vue-recaptcha>
                <v-btn
                  :disabled="!valid"
                  color="primary"
                  :dark="valid"
                  rounded
                  block
                  class="mt-3"
                  @click="submit"
                  :loading="sendLoad"
                >
                  Enviar
                </v-btn>
              </v-form>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container> -->
    <div class="svg-border-waves text-white">
      <v-img src="~@/assets/img/borderWavesBlue.svg" @load="mixpanel.track('Carregou a borda do fundo')"/>
    </div>
    <v-snackbar
      v-model="snackbar.enabled"
      timeout="3000"
      right
      top
      :color="snackbar.color"
    >
      {{ snackbar.text }}

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.enabled = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </section>
</template>

<style scoped>
#contact {
  background-color: #f4f7f5;
}

.svg-border-waves .v-image {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3rem;
  width: 100%;
  overflow: hidden;
}
</style>

<script>
import { db, mixpanel } from "@/main";
import { collection, addDoc } from "firebase/firestore";
import { VueRecaptcha } from "vue-recaptcha";

export default {
  data: () => ({
    mixpanel,
    siteKey: "6LdsD6seAAAAABs3ygQk79mjm3lODYl0Mm6G8Ndz",
    recaptcha: "",
    icons: ["fa-facebook", "fa-twitter", "fa-linkedin", "fa-instagram"],
    valid: true,
    name: "",
    nameRules: [
      (v) => !!v || "O campo nome é obrigatório",
      (v) => (v && v.length >= 6) || "O nome precisa ter mais de 6 caracteres",
    ],
    email: "",
    emailRules: [
      (v) => !!v || "O campo email é obrigatório",
      (v) => /.+@.+\..+/.test(v) || "O E-mail precisa ser válido",
    ],
    textArea: "",
    textAreaRules: [
      (v) => !!v || "O campo de texto é obrigatório",
      (v) => (v && v.length >= 10) || "Mínimo de 10 caracteres",
    ],
    lazy: false,
    snackbar: {
      enabled: false,
      text: "",
      color: "",
    },
    messageText: "",
    disableSubmit: true,
    sendLoad: false,
  }),
  components: { VueRecaptcha },
  methods: {
    async submit() {
      this.messageText = this.name + this.email + this.textArea;
      this.valid = false;
      this.sendLoad = true;
      if (this.recaptcha) {
        mixpanel.identify();
        mixpanel.register({ Name: this.name, Email: this.email });
        mixpanel.people.set({
          $email: this.email,
          $name: this.name,
        });
        mixpanel.track('Submitted form', {
          'name':this.name,
          'email': this.email,
          'message': this.textArea
        });
        try {
          const docRef = await addDoc(collection(db, "contactData"), {
            created_at: Date.now(),
            name: this.name,
            email: this.email,
            message: this.textArea,
          });
          this.snackbar.text = "Mensagem enviada com sucesso";
          this.snackbar.color = "success";
          this.snackbar.enabled = true;
          console.log("Document written with ID: ", docRef.id);
        } catch (e) {
          this.snackbar.text = "Erro ao enviar mensagem";
          this.snackbar.color = "danger";
          this.snackbar.enabled = true;
          console.error("Error adding document: ", e);
          this.messageText = "";
        }
      } else this.errorMethod;
      this.sendLoad = false;
    },
    checkSubmit() {
      if (!this.recaptcha) this.$refs.invisibleRecaptcha.execute();
      if (this.messageText) {
        this.valid = this.messageText != this.name + this.email + this.textArea;
        this.$refs.form.validate();
      }
    },
    onVerify: function (response) {
      this.recaptcha = response;
      // console.log("Verify: " + response);
    },
    onExpired: function () {
      recaptcha = "";
      console.log("Recaptcha Expired");
    },
    resetRecaptcha() {
      this.$refs.recaptcha.reset(); // Direct call reset method
    },
    errorMethod() {
      this.snackbar.text = "Recaptcha Inválido";
      this.snackbar.color = "danger";
      this.snackbar.enabled = true;
      this.$refs.invisibleRecaptcha.reset();
      this.messageText = "";
    },
  },
};
</script>